<template>
  <div
    v-show="show"
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdFormInvalidFeedback',

  inheritAttrs: false,

  props: {
    state: {
      type: [Boolean, String],
      default: null
    },
    forceShow: {
      type: Boolean,
      default: false
    }
  },

  emits: [],

  computed: {
    show() {
      return this.state === false || this.forceShow;
    },

    feedbackClasses() {
      const classes = ['invalid-feedback'];

      if (this.show) classes.push('d-block');

      return classes;
    },

    mergedClasses() {
      return [this.$attrs.class, this.feedbackClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
